import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAssetKpis } from '@/hooks/useAssetKpis';
import { CashFlowChart } from './CashFlowChart';
import { CustomizableAssetKpis } from './CustomizableAssetKpis';
import { IncomeExpenseChart } from './IncomeExpenseChart';

interface MonthlyData {
  month: string;
  cashFlow: number;
}

interface IncomeExpenseData {
  month: string;
  income: number;
  expenses: number;
}

export function RentalKpiDashboard({ assetId }: { assetId: string }) {
  const {
    data: kpis,
    loading,
    error,
  } = useAssetKpis(assetId, {
    period: 'annual',
    includeVacancy: true,
    includeAppreciation: true,
  });

  if (loading) return <div className="py-8 text-center">Loading KPIs...</div>;
  if (error)
    return <div className="py-8 text-center text-red-500">{error}</div>;
  if (!kpis) return <div>No KPI data available.</div>;

  const metrics = kpis as Record<string, unknown>;
  const calculationErrors = metrics.calculation_errors as string[] | undefined;

  return (
    <div className="space-y-6">
      {/* Customizable KPI Cards */}
      <CustomizableAssetKpis
        assetId={assetId}
        assetData={metrics}
        onRefresh={() => {
          // Trigger a refetch of the KPI data
          window.location.reload();
        }}
      />
      {/* Performance Charts section removed */}
    </div>
  );
}
